export const SAVE_LOGIN_DATA = 'SAVE_LOGIN_DATA'
export const SAVE_LOGIN_DATA_SUCCESS = 'SAVE_LOGIN_DATA_SUCCESS'
export const SAVE_LOGIN_DATA_FAIL = 'SAVE_LOGIN_DATA_FAIL'

export const saveLoginData = (params) => {
    return { type: SAVE_LOGIN_DATA, params }
}
 